import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { Controller } from 'react-hook-form';

import type { FormFieldProps } from './types';

const FormFieldInput = ({
    type,
    min,
    placeholder,
    name,
    error,
    control,
    label,
    required,
    disabled,
}: FormFieldProps) => {
    const setLabel = required ? (
        <div className='InputText__madatoryLabel'>
            <OverlayTrigger
                placement='top-start'
                overlay={
                    <Tooltip>
                        <p>Mandatory field</p>
                    </Tooltip>
                }
            >
                <label className='InputText__label' htmlFor={name}>
                    {label}
                </label>
            </OverlayTrigger>
            <span className='InputText__mandatoryIcon'>*</span>
        </div>
    ) : (
        <label className='InputText__label' htmlFor={name}>
            {label}
        </label>
    );

    return (
        <div className={`form-group ${error && 'has-error has-feedback'}`}>
            {setLabel}
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <input
                        className='form-control'
                        min={min}
                        value={field.value ?? ''}
                        required={required}
                        onChange={item => {
                            field.onChange(item);
                        }}
                        type={type}
                        disabled={disabled}
                        placeholder={placeholder}
                    />
                )}
            />
            {error && (
                <>
                    <span className='form-control-feedback rioglyph rioglyph-error-sign top-27' />
                    <span className='help-block'>
                        <span>{error.message}</span>
                    </span>
                </>
            )}
        </div>
    );
};

export default FormFieldInput;
